<template>
  <div
      class="room-alert-component"
      @keydown="keymap"
  >
    <div class="room-alert">
      <div class="room-alert-header"></div>
      <div class="room-alert-body">
        <div class="alert-text-container">
          <p class="alert-text title">{{ title }}</p>
          <p class="alert-text text" v-html="text" />
          <div v-if="type === 'input'"
               class="alert-input-container flex justify-center items-center"
          >
            <input v-model="inputValue"
                   ref="input"
                   class="alert-input"
                   type="text"
                   :id="`alert_${type}`"
                   @keyup.enter="onClickOk"
            />
          </div>
        </div>
        <img v-if="imgSrc" :src="imgSrc" class="alert-image" />
      </div>
      <div class="room-alert-footer">
        <div class="button-list">
          <button class="button-item cancel" v-if="!onlyOk" @click="onClickCancel">{{ cancelText }}</button>
          <button class="button-item ok" @click="onClickOk">{{ okText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrmCamstudyAlert',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    title: {
      type: String,
      default: function() {return this.$t('common.alert.title')}
    },
    text: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: function() {return this.$t('common.cancel')}
    },
    okText: {
      type: String,
      default: function() {return this.$t('common.confirm')}
    },
    ok: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    onlyOk: {
      type: Boolean,
      default: false
    },
    finally: {
      type: Function,
      default: () => {}
    },
    imgSrc: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data(){
    return{
      inputValue: '',
    }
  },
  mounted() {
    setTimeout(() => {
      if(this.type === 'input'){
        this.$refs.input.focus();
      }
    }, 100)
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 27: // esc
          this.onClickCancel();
          break
      }
    },
    onClickCancel() {
      try{
        this.cancel();
      }finally{
        this.destroy({fade: false});
        this.finally();
      }
    },
    onClickOk() {
      try{
        if (this.type === 'input' && this.inputValue !== ''){
          this.ok(this.inputValue)
        } else {
          this.ok();
        }

        if (this.$parent.callback) {
          this.$parent.callback()
        }
      }finally{
        this.destroy({fade: false});
        this.finally();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.room-alert-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.room-alert {
  border-radius: 12px;
  background: #313131;
  width: calc(100% - 16px);
  max-width: 374px;
  box-sizing: border-box;
  text-align: center;
}
.alert-text-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 25px 20px 20px 20px;
  line-height: 1.5;
}
.alert-text {
  &.title {
    color: #FFF;
    font-size: 14px;
    font-weight: 700;
    padding: 0 20px;
  }
  &.text {
    color: #FFF;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    padding: 0 20px;
  }
}
.room-alert-footer {
  border-top: 0.333px solid rgba(255, 255, 255, 0.20);
}
.button-list {
  display: flex;
  justify-content: center;
  gap: 0 10px;
  .button-item{
    width: 100%;
    padding: 15px 0px 14px 0px;
    color: #FFF;
    font-size: 14px;
    line-height: 150%;
    &.cancel {
      color: #999;
    }
    &.ok{
      font-weight: 700;
    }
  }
}
//.button {
//  min-width: 100px;
//  border-radius: 6px;
//  padding: 0 24px;
//  font-size: 15px;
//  line-height: 40px;
//  transition: 0.1s ease-out;
//  &.cancel {
//    background-color: #f1f2f3;
//    color: #666;
//    &:hover {
//      background-color: #ddd;
//    }
//  }
//  &.ok {
//    background-color: $mainColor;
//    color: #fff;
//    &:hover {
//      background-color: $subColor;
//    }
//  }
//}
.alert-input-container {
  margin-top: 12px;
  gap: 6px;
}
.alert-input{
  padding: 8px 14px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  background-color: #f4f4f4;
  font-size: 14px;
  font-weight: bold;
  color: #333;

  &:focus {
    background-color: white;
    border-color: #59f;
    box-shadow: 0 6px 18px rgb(0 0 0 / 20%);
  }
}
//.alert-label {
//  font-size: 14px;
//  color: #666;
//  cursor: pointer;
//}
.alert-image{
  padding-bottom: 20px;
}
.room-alert-body{
  padding: 0 20px;
}
[grm-device-mobile]{
  @media(orientation: landscape){
    .room-alert{
      max-height: calc(100% - 16px);
      .room-alert-body{
        max-height: calc(100dvh - 16px - 50.5px);
        overflow: scroll;
      }
    }
  }
}
</style>